import { toast } from "react-toastify";
import * as actions from "./actionTypes"
import { refreshToken } from "./crud";

export const getToken = (token) => ({
  type : actions.getToken,
  payload: token
});

export const getUser = (user) => ({
  type : actions.getUser,
  payload: user
});

export const setAuth = (auth) => ({
  type : actions.setAuth,
  payload: auth
})



export const changeToken = (token) => {
    return function (dispatch) {
      refreshToken(token).then((resp) => {
        dispatch(getToken(resp.data))
      }).catch(function (error) {
        if(error.response.status === 401) {
          dispatch(setAuth(null));
          toast.error('Sorry your token has bee expired...!', {position: toast.POSITION.BOTTOM_RIGHT}, { autoClose: 7000 })
        } else {
          toast.warning('Sorry you have network problems....!', {position: toast.POSITION.BOTTOM_RIGHT}, { autoClose: 7000 })
        }
      })
    }
}